var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2857 17V18H2.28566V17L4.28566 15V9C4.28566 5.9 6.31566 3.17 9.28566 2.29V2C9.28566 1.46957 9.49638 0.960859 9.87145 0.585786C10.2465 0.210714 10.7552 0 11.2857 0C11.8161 0 12.3248 0.210714 12.6999 0.585786C13.0749 0.960859 13.2857 1.46957 13.2857 2V2.29C16.2557 3.17 18.2857 5.9 18.2857 9V15L20.2857 17ZM13.2857 19C13.2857 19.5304 13.0749 20.0391 12.6999 20.4142C12.3248 20.7893 11.8161 21 11.2857 21C10.7552 21 10.2465 20.7893 9.87145 20.4142C9.49638 20.0391 9.28566 19.5304 9.28566 19M19.0357 1.19L17.6157 2.61C18.4614 3.44542 19.133 4.44042 19.5913 5.53732C20.0496 6.63422 20.2856 7.8112 20.2857 9H22.2857C22.2857 6.07 21.1257 3.25 19.0357 1.19ZM0.285664 9H2.28566C2.28566 6.6 3.24566 4.3 4.95566 2.61L3.53566 1.19C2.50354 2.21157 1.68473 3.42807 1.12681 4.76881C0.568878 6.10955 0.28296 7.54781 0.285664 9Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_16883",
    x1: 11.2856,
    y1: -3.78,
    x2: 11.2856,
    y2: 24.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.1e528b4d29b708c69d305ca0edd3b745.svg";
export { ForwardRef as ReactComponent };